import { createFileRoute } from '@tanstack/react-router'
import { CandidatePools } from '@/features/candidate-pool'

export const Route = createFileRoute('/_authenticated/candidate-pools/')({
  component: CandidatePools,
})
